import { useUrlGenerator } from '@folklore/routes';
import classNames from 'classnames';
import PropTypes from 'prop-types';
import { FormattedMessage, useIntl } from 'react-intl';

import * as AppPropTypes from '../../lib/PropTypes';

import { useTheme, useThemeClassName } from '../../contexts/ThemeContext';
import StyledButton from '../buttons/StyledButton';
import Accordion from '../partials/Accordion';
import Body from '../partials/Body';

import styles from '../../../styles/prizes/prize.module.scss';

const propTypes = {
    className: PropTypes.string,
    nameClassName: PropTypes.string,
    prize: AppPropTypes.prize,
    prizeTitle: PropTypes.string,
};

const defaultProps = {
    className: null,
    nameClassName: null,
    prize: null,
    prizeTitle: null,
};

function PrizeDefault({ className, nameClassName, prize, prizeTitle }) {
    const intl = useIntl();
    const { name: theme } = useTheme();
    const themeClassName = useThemeClassName(styles);

    const {
        prize: prizeObject,
        uuid: prizeUuid,
        claimed = false,
        requiresForm = false,
    } = prize || {};

    const { image, name, description, legal = null } = prizeObject || {};
    const { url: imageUrl = null } = image || {};
    const route = useUrlGenerator();

    return (
        <div
            className={classNames([
                styles.container,
                themeClassName,
                {
                    [className]: className !== null,
                },
                'prize-default',
            ])}
        >
            <div className={classNames([styles.inner, 'inner'])}>
                {prizeTitle ? <h4 className={styles.prizeTitle}>{prizeTitle}</h4> : null}
                <div className={classNames([styles.top, 'top'])}>
                    {imageUrl !== null ? (
                        <div className={classNames([styles.imageContainer, 'image-container'])}>
                            <img
                                className={classNames([styles.image, 'image'])}
                                src={imageUrl}
                                alt={name}
                            />
                        </div>
                    ) : null}
                    <div className={classNames([styles.text, 'text'])}>
                        <div
                            className={classNames([
                                styles.name,
                                { [nameClassName]: nameClassName !== null },
                                'name',
                            ])}
                            dangerouslySetInnerHTML={{ __html: name }}
                        />
                        <div
                            className={classNames([styles.description, 'description'])}
                            dangerouslySetInnerHTML={{ __html: description }}
                        />
                    </div>
                </div>
                {!claimed && requiresForm ? (
                    <StyledButton
                        className={classNames([styles.button, 'button'])}
                        href={route('prize', { participant_prize: prizeUuid })}
                    >
                        <FormattedMessage
                            defaultMessage="Claim my prize"
                            description="Button label"
                        />
                    </StyledButton>
                ) : (
                    <div className={classNames([styles.claimed, 'claimed'])}>
                        {theme === 'iga' ? (
                            <FormattedMessage
                                defaultMessage="Thank you, you will receive your prize in the mail shortly."
                                description="Description label"
                            />
                        ) : (
                            <FormattedMessage
                                defaultMessage="Thank you, this prize has been claimed."
                                description="Description label"
                            />
                        )}
                    </div>
                )}
            </div>
            {legal !== null ? (
                <Accordion
                    label={intl.formatMessage({
                        defaultMessage: 'Information',
                        description: 'Coupon accordion title',
                    })}
                    className={styles.accordion}
                    buttonClassName={styles.accordionButton}
                    labelClassName={styles.accordionLabel}
                    iconClassName={styles.accordionIcon}
                    contentClassName={styles.accordionContent}
                >
                    <Body className={styles.legal} body={legal} />
                </Accordion>
            ) : null}
        </div>
    );
}

PrizeDefault.propTypes = propTypes;
PrizeDefault.defaultProps = defaultProps;

export default PrizeDefault;
